module.exports = __webpack_public_path__ + "152110eca8a2ce8397aee10a4596fae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lejemaaldk.png
// module id = 60
// module chunks = 0